<template>
  <div>
   <div class="ss">
     <!-- <div class="contact_us" @click="btn_bot">
       <div style="color: #00B4FF; text-align: center; margin-top: 9px; font-weight: 700;">
         <i class="iconfont icon-lianxiwomen" ></i>
       </div>
       <div class="us">
         联系我们
       </div>
     </div> -->
     <div class="top" @click="btn_top">
       <div style="text-align: center;line-height: 44px;">
         <i class="iconfont icon-huidaodingbu"></i>
       </div>
     </div>
   </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      // 回到顶部
      btn_top() {
          cancelAnimationFrame(this.timer)
               const self = this
               self.timer = requestAnimationFrame(function fn () {
                 const oTop = document.body.scrollTop || document.documentElement.scrollTop
                 if (oTop > 0) {
                   document.body.scrollTop = document.documentElement.scrollTop = oTop - 100
                   self.timer = requestAnimationFrame(fn)
                 } else {
                   cancelAnimationFrame(self.timer)
                 }
               })
      },
      btn_bot() {
        window.scrollTo(0,50000);
      }
    }
  }
</script>

<style scoped>
  .ss {
    position: fixed;
    bottom: 200px;
    right: 0;
    z-index: 99;
    margin-right: 10px;
  }
  .contact_us {
    width: 44px;
    height: 127px;
    background: linear-gradient(132deg, #F3F5F8 0%, #FFFFFF 100%);
    /* box-shadow: 8px 8px 20px 0px rgba(55, 141, 170, 0.1), -8px -8px 20px 0px #FFFFFF; */
    border-radius: 22px;
    border: 2px solid #FFFFFF;
    cursor: pointer;
  }
  .us {
    width: 18px;
    height: 80px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 700;
    color: #000000;
    line-height: 20px;
    margin-left: 14px;
  }
  .top {
    width: 44px;
    height: 44px;
    background: linear-gradient(132deg, #F3F5F8 0%, #FFFFFF 100%);
    /* box-shadow: 8px 8px 20px 0px rgba(55, 141, 170, 0.1), -8px -8px 20px 0px #FFFFFF; */
    border: 2px solid #FFFFFF;
    border-radius: 50%;
    margin-top: 25px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/backToTheTop.vue